export type Locale = 'de' | 'en';

export const LOCALES: readonly Locale[] = ['de', 'en'] as const;

/** Grammatisches Geschlecht. Im Englischen ungenutzt, dort immer 'n'. */
export type Gender = 'm' | 'f' | 'n';

export type GrammaticalCase = 'nom' | 'acc' | 'dat' | 'gen';

export type GrammaticalNumber = 'sg' | 'pl';

export type ArticleKind = 'def' | 'indef' | 'none';

/**
 * Ein Substantiv mit allen Angaben, die zum korrekten Flektieren noetig sind.
 *
 * Ohne diese Metadaten laesst sich im Deutschen kein prozeduraler Satz bauen:
 * "Du birgst " + "Wrack" ergibt Murks, "Du birgst das Wrack" braucht Genus und Kasus.
 */
export interface NounEntry {
  /** Nominativ Singular, im Deutschen grossgeschrieben. */
  readonly sg: string;
  /** Nominativ Plural. */
  readonly pl: string;
  /** Genus. Fuer Englisch irrelevant, dort weggelassen. */
  readonly gender?: Gender;
  /** Abweichender Genitiv Singular, wenn die Standardregel nicht greift. */
  readonly gen?: string;
  /** Abweichender Dativ Plural, wenn die Standardregel nicht greift. */
  readonly datPl?: string;
  /**
   * Erzwingt im Englischen "an" statt "a" bzw. umgekehrt — noetig bei
   * Woertern wie "hour" (an) oder "unit" (a), wo der Anfangsbuchstabe traegt.
   */
  readonly an?: boolean;
}

export type NounTable = Readonly<Record<string, NounEntry>>;

/** Wie ein Substantiv in einem Satz erscheinen soll. */
export interface NounRequest {
  readonly id: string;
  readonly article: ArticleKind;
  readonly case: GrammaticalCase;
  readonly number: GrammaticalNumber;
  /** Ersten Buchstaben grossschreiben (Satzanfang im Englischen). */
  readonly caps: boolean;
  /**
   * Vorangestellte Praeposition. Im Deutschen noetig, weil sie mit dem Artikel
   * verschmelzen kann ("von dem Wrack" → "vom Wrack", aber "von der Rettungsinsel"
   * bleibt getrennt). Die Vorlage kann das Genus nicht kennen, wenn das Substantiv
   * erst zur Laufzeit gewaehlt wird — deshalb gehoert die Regel hierher.
   */
  readonly prep?: string;
}

/** Werte, die in eine Nachricht eingesetzt werden koennen. */
export type MessageParams = Readonly<Record<string, string | number | boolean>>;
